import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {},
  infoBoard: {
    //zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    paddingLeft: 5,
    backgroundColor: "transparent",
    boxShadow: "none",
    position: "relative",
    paddingRight: 5,
    paddingTop: 0,
    zIndex: 9,
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 100,
    },
  },
  infoBoardShift: {
    width: 'auto',
    minWidth: '80%',
    transition: theme.transitions.create(["width", "padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    zIndex: 9,
    [theme.breakpoints.up("lg")]: {
      paddingLeft: drawerWidth,
    },
  },
  navigaitonBlock: {
    zIndex: 99,
  },
  screen: {
    height: "100%",
  },
  hamburger: {
    padding: "0 10px ",
    display: "block",
    width: "45px",
    marginTop: "20px",
  },
}));

export default useStyles;
